import { render, staticRenderFns } from "./Thankyou.vue?vue&type=template&id=a149c0c4&"
import script from "./Thankyou.vue?vue&type=script&lang=ts&"
export * from "./Thankyou.vue?vue&type=script&lang=ts&"
import style0 from "./Thankyou.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Thankyou.vue"
export default component.exports